// AuthLayout.jsx'in bağımsız kopyası — customer auth bileşenine dokunmadan,
// aynı CSS sınıflarıyla (auth-screen/auth-aside/...) yayıncıya özel metinle.
import { useTranslation } from 'react-i18next';
import Logo from '../../components/Logo';
import LanguageToggle from '../../components/LanguageToggle';
import ThemeToggle from '../../components/ThemeToggle';
import Icon from '../../components/Icon';
import { AsideRings } from '../../components/illustrations';

export default function PublisherAuthLayout({ children }) {
  const { t } = useTranslation();
  const points = ['publisher.aside_point1', 'publisher.aside_point2', 'publisher.aside_point3'];

  return (
    <div className="auth-screen">
      <aside className="auth-aside">
        <Logo />
        <div className="aside-visual">
          <AsideRings />
        </div>
        <div className="aside-body">
          <span className="eyebrow">{t('publisher.eyebrow')}</span>
          <h2>{t('publisher.aside_title')}</h2>
          <p style={{ marginBottom: 'var(--sp-5)' }}>{t('publisher.aside_desc')}</p>
          <ul style={{ listStyle: 'none', display: 'grid', gap: 'var(--sp-3)' }}>
            {points.map((p) => (
              <li key={p} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', color: 'var(--text-2)', fontSize: 14 }}>
                <span style={{ color: 'var(--accent)', marginTop: 2, flexShrink: 0 }}>
                  <Icon name="check" size={16} />
                </span>
                {t(p)}
              </li>
            ))}
          </ul>
        </div>
      </aside>

      <main className="auth-main">
        <div className="auth-card">
          <div className="auth-topbar">
            <Logo />
            <div style={{ display: 'flex', gap: 8 }}>
              <ThemeToggle />
              <LanguageToggle />
            </div>
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
